<template>
  <move-template :order-type="queryParam.value.business.orderType" :type="type" />
</template>

<script>
  import MoveTemplate from '@/views/warehouse_management/movebound/MoveTemplate.vue'

  export default {
    name: 'CommonMoveOrder',
    components: { MoveTemplate },
    props: {
      queryParam: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        type: 'movementTransfer'
      }
    },
    methods: {}
  }
</script>